








import {
    defineComponent,
    onMounted,
    useContext,
    watch
} from '@nuxtjs/composition-api'

export default defineComponent({
    name: 'Guest',
    setup: () => {
        const context = useContext()
        const { $apiGuest, route } = context

        const fetchRedirects = async () => {
            const { data } = await $apiGuest.settingsRedirectGetRedirectUrlForCurrentPage(
                {
                    currentPage: window.location.href
                }
            )

            if (data.redirectURL) {
                const redirectUrl = new URL(data.redirectURL, window.location.origin)

                Object.entries(route.value.query).forEach(([ key, value ]) => {
                    if (!redirectUrl.searchParams.has(key)) {
                        redirectUrl.searchParams.append(key, value)
                    }
                })

                if (window.location.href === redirectUrl.toString()) return

                window.location.href = redirectUrl.toString()
            }
        }

        watch(
            () => route.value,
            fetchRedirects
        )

        onMounted(async () => {
            await fetchRedirects()
        })
    }
})
